import { useState } from 'react';
import { Headphones } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { ContactSupportForm } from './ContactSupportForm';
import { cn } from '@/lib/utils';

interface Props {
  className?: string;
  variant?: 'header' | 'mobile' | 'inline';
  label?: string;
}

export function ContactUsButton({ className, variant = 'header', label = 'Contact Us' }: Props) {
  const [open, setOpen] = useState(false);

  const triggerCls =
    variant === 'header'
      ? 'inline-flex items-center gap-1.5 px-2.5 py-1 text-[12px] font-semibold text-primary-foreground/90 hover:text-primary-foreground hover:bg-primary-foreground/10 rounded transition-colors uppercase tracking-wide'
      : variant === 'mobile'
      ? 'w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-primary text-primary-foreground font-semibold text-sm shadow-sm'
      : 'inline-flex items-center gap-2 px-3 py-2 rounded-md border bg-background text-sm font-medium hover:bg-accent';

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" className={cn(triggerCls, className)}>
          <Headphones className="h-3.5 w-3.5" />
          <span>{label}</span>
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Contact Customer Support</DialogTitle>
          <DialogDescription>
            We typically respond within a few hours. Urgent issues are escalated automatically.
          </DialogDescription>
        </DialogHeader>
        <ContactSupportForm onSubmitted={() => setTimeout(() => setOpen(false), 4000)} />
      </DialogContent>
    </Dialog>
  );
}
